export const API_URL = "https://api.dent-scan.com";
export const SMS_API = "https://api.releans.com/v2/message";
export const SENDER_ID = "DENT SCAN";
export const SMS_API_KEY = "1bbee3794a2bbd75edf0ab119f02d73c";
